import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class SignUpPrompt implements AnalyticsObject {
  name: string
  properties: SignUpPromptProperties
  constructor(properties: SignUpPromptProperties) {
    this.name = 'Sign-up Prompt'
    this.properties = properties
  }
}
export interface SignUpPromptProperties extends AnalyticsProperties {
  signUpPrompt: {
    type: SignUpPromptType
    button?: SignUpButton
    title?: string
    topic?: string
  }
  pageMetaContext?: {
    countryFrom: string | null
    countryTo: string | null
    payout: string | null
    provider: string | null
  } | null
}

export enum SignUpPromptType {
  ComparisonAlert = 'Comparison Alert',
  NewProviderAlertNoResults = 'New provider (no results)',
  NewProviderAlertPoorResults = 'New provider (poor results)',
  GenericLeadCapture = 'Generic Lead Capture',
}

export type SignUpButton = 'Email' | 'Google'
